import { render, staticRenderFns } from "./SectionQuote.vue?vue&type=template&id=59c0e040&"
import script from "./SectionQuote.vue?vue&type=script&lang=js&"
export * from "./SectionQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports